'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpinner = exports.Spinner = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _SpinnerStyle = require('./Spinner.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = exports.Spinner = function Spinner(_ref) {
  var className = _ref.className,
      color = _ref.color,
      max = _ref.max,
      min = _ref.min,
      mode = _ref.mode,
      size = _ref.size,
      strokeWidth = _ref.strokeWidth,
      value = _ref.value;

  var determinateStyles = {};

  // Set determinate styles
  if (mode === 'determinate') {
    var relVal = (0, _SpinnerStyle.getRelativeValue)(value, min, max);

    determinateStyles.SVG = {
      animation: 'none'
    };
    determinateStyles.innerCircle = {
      animation: 'none',
      transition: 'all 0.3s linear',
      strokeDasharray: (0, _SpinnerStyle.getArcLength)(relVal, size, strokeWidth) + ', ' + (0, _SpinnerStyle.getArcLength)(1, size, strokeWidth),
      opacity: relVal > 0 ? 1 : 0
    };
  }

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      _react2.default.createElement(
        'svg',
        {
          className: 'SVG',
          height: size,
          style: determinateStyles.SVG,
          width: size,
          viewBox: '0 0 ' + size + ' ' + size,
          xmlns: 'http://www.w3.org/2000/svg' },
        _react2.default.createElement('circle', {
          style: determinateStyles.innerCircle,
          className: 'innerCircle',
          stroke: color,
          fill: 'none',
          strokeWidth: strokeWidth,
          strokeLinecap: 'round',
          cx: size / 2,
          cy: size / 2,
          r: (size - strokeWidth) / 2 })
      )
    )
  );
};

Spinner.propTypes = {
  /**
   * This property is required to apply glamorous styles to the component.
   * It is not necessary to add a className, but it will be merged with the glamorous className if you do
   */
  className: _propTypes2.default.string,
  /**
   * The string to determine the color of the stroke. Defaults to theme ternary
   */
  color: _propTypes2.default.string,
  /**
   * The max value of progress - only works in determinate mode
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress - only works in determinate mode
   */
  min: _propTypes2.default.number,
  /**
   * The string to determine spinner mode. Provide value if set to 'deterministic'
   */
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
  /**
   * Determines the size of the spinner
   */
  size: _propTypes2.default.number,
  /**
   * Determines the size of the spinners stroke width
   */
  strokeWidth: _propTypes2.default.number,
  /**
   * The value of progress - only works in determinate mode
   */
  value: _propTypes2.default.number
};

var StyledSpinner = exports.StyledSpinner = (0, _glamorous2.default)(Spinner)(_SpinnerStyle.defaultStyle, _SpinnerStyle.mapPropsAndThemeToStyle);

StyledSpinner.defaultProps = {
  min: 0,
  max: 100,
  mode: 'indeterminate',
  size: 55,
  strokeWidth: 5,
  value: 0
};

exports.default = StyledSpinner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Spinner/Spinner.js
// module id = 615
// module chunks = 0